import { render, staticRenderFns } from "./fhir-page-add.vue?vue&type=template&id=2c22e225&"
import script from "./fhir-page-add.vue?vue&type=script&lang=js&"
export * from "./fhir-page-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports